import React from 'react'
import ContentReview from '../../admin/ContentReview'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3ContentReviewPage() {
  return (
    <V3PageBridgeFrame>
      <ContentReview />
    </V3PageBridgeFrame>
  )
}
